import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { CONFIG as ETHEREUM_CONFIG } from './configs/ethereum';
import { CONFIG as BITCOIN_CONFIG } from './configs/bitcoin';
import { CONFIG as SOLANA_CONFIG } from './configs/solana';

const CONFIG = process.env.REACT_APP_CONFIG === 'bitcoin' ? BITCOIN_CONFIG : 
               process.env.REACT_APP_CONFIG === 'solana' ? SOLANA_CONFIG : 
               ETHEREUM_CONFIG;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
